export class Parametro {
    constructor(public tipo: string, public id_sistema: number,  public id_parametro: number, public nom_parametro: string, public valor_parametro: string, public nombre_usuario: string) {}
}